<template>
    <v-card
        elevation="2"
        outlined
        class="pa-5"
    >
        <v-card-title>Member code</v-card-title>
        <v-data-table
            :headers="headers"
            :items="memberData"
            item-key="code"
            class="row-pointer"
            @click:row="filterMember"
        />
    </v-card>
</template>
<script>
import   { setMemberFilter }  from '../services/ticketTabs';
export default {
    props: {
        memberData: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Code',
                    value: 'member_code',
                },
                {
                    text: 'Total Tickets',
                    value: 'count',
                    align: 'end',
                },
            ],
            label: 'Dashboard',
            ticketTabs: [],
        };
    },
    methods: {
        filterMember(item) {
            setMemberFilter(item.member_code);
        },          
    },
};

</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
